import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LDAPUsersViewModelType from '@/ViewModels/Controls/LDAPUsersViewModel';
import CoreFrameGridType from '@/Controls/CoreFrameGridControl';

export default class LDAPUsers extends Control {

    private CoreFrameGrid = ComponentManager.getControl<typeof CoreFrameGridType>('CoreFrameGrid');
    private jQueryControl: JQuery;
    private grid: CoreFrameGridType;

    public constructor(private viewModel: LDAPUsersViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'LDAPUsers',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible
        });

        if (this.viewModel.grid != null) {
            this.grid = new this.CoreFrameGrid(this.viewModel.grid);
            let tuple = this.grid.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('LDAPUsers', LDAPUsers, 'RADPresentation.HTMLClient.DefaultViewExtensions');